<div class="offcanvas-header">
    <h5 class="offcanvas-title">All Staff</h5>
    <button type="button" class="btn-close text-reset" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="offcanvas-body">
    <sf-input label="Search Staff" [formControl]="search" [placeholder]="searchPlaceholder()"></sf-input>

    @for (staff of filteredStaff(); track staff.id) {
        <sf-staff-detail
            [staff]="staff"
            (sendPushNotificationOpened)="activeOffcanvas.dismiss()"
            class="mb-2"></sf-staff-detail>
    }
</div>
<div class="offcanvas-footer">
    <div class="d-grid gap-2">
        <button sfButton type="button" color="danger" size="lg" (click)="close()">Close</button>
    </div>
</div>
